import React, { Component } from "react";
import Fade from "react-reveal";

let id = 0;
class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalImage: null,
      modalTitle: "",
    };
  }

  openModal = (imageSrc, title) => {
    this.setState({
      modalImage: imageSrc,
      modalTitle: title,
    });
    document.body.style.overflow = "hidden";
  };

  closeModal = () => {
    this.setState({
      modalImage: null,
      modalTitle: "",
    });
    document.body.style.overflow = "auto";
  };

  handleBackdropClick = (e) => {
    if (e.target.classList.contains("portfolio-modal")) {
      this.closeModal();
    }
  };

  componentWillUnmount() {
    document.body.style.overflow = "auto";
  }

  render() {
    if (!this.props.data) return null;

    const projects = this.props.data.projects.map((project) => {
      let projectImage = "./images/portfolio/" + project.image;
      let projectUrl = project.url;
      let projectSource = project.source;

      return (
        <div key={id++} className="portfolio-item">
          <div className="item-wrap">
            <div className="title-portfolio">{project.title}</div>

            <div
              className="image-container"
              onClick={() => this.openModal(projectImage, project.title)}
            >
              <img src={projectImage} alt={project.title} loading="lazy" />
            </div>

            {/* tech */}
            <div className="tech-container">
              <p className="tech-text">{project.tech}</p>
            </div>
            {/* category */}
            <div className="category-container">
              <p className="category-text">{project.category}</p>
            </div>

            <div className="links-container">
              <a rel="noreferrer" target="_blank" href={projectUrl}>
                {"Demo"}
              </a>
              <a rel="noreferrer" target="_blank" href={projectSource}>
                {"Source"}
              </a>
            </div>
          </div>
        </div>
      );
    });

    return (
      <section id="portfolio">
        <Fade left duration={1000} distance="40px">
          <div className="row">
            <div className="twelve columns collapsed">
              <h1>Some of My Works</h1>

              <div id="portfolio-wrapper">{projects}</div>
            </div>
          </div>
        </Fade>

        {/* مودال برای نمایش تصویر بزرگ */}
        <div
          className={`portfolio-modal ${this.state.modalImage ? "active" : ""}`}
          onClick={this.handleBackdropClick}
        >
          {this.state.modalImage && (
            <div className="portfolio-modal-content">
              <span className="portfolio-modal-close" onClick={this.closeModal}>
                ×
              </span>
              <img src={this.state.modalImage} alt={this.state.modalTitle} />
            </div>
          )}
        </div>
      </section>
    );
  }
}

export default Portfolio;
